import React, { Component } from 'react';
import { Icon } from 'ui';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';

class FeaturedContentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      checked: !!props.id,
      id: props.id,
    };
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  handleError() {
    this.setState({ loading: false });
  }

  handleCheckboxChange(e) {
    this.setState({ loading: true, checked: e.target.checked }, () => {
      if (this.state.id) {
        this.unFeatureContent();
      } else {
        this.featureContent();
      }
    });
  }

  featureContent() {
    request
      .postJSON(routes.FEATURED_CONTENTS, {
        content_id: this.props.contentId,
        content_type: this.props.contentType,
      })
      .then(data => {
        this.setState({ id: data.featured_content.id, loading: false });
      })
      .fail(this.handleError);
  }

  unFeatureContent() {
    request
      .delete(routes.FEATURED_CONTENT(this.state.id))
      .then(() => {
        this.setState({ id: null, loading: false });
      })
      .fail(this.handleError);
  }

  render() {
    return (
      <h3 className="Module-heading SectionHeading">
        {t('learn.featured_content.feature_lesson')}
        <Icon
          name="info"
          className="Module-headingIcon"
          data-toggle="tooltip"
          data-original-title={t(
            'learn.featured_content.feature_lesson_tooltip',
          )}
        />
        <input
          checked={this.state.checked}
          onChange={this.handleCheckboxChange}
          className="pull-right"
          type="checkbox"
          disabled={this.state.loading}
        />
      </h3>
    );
  }
}

export default FeaturedContentForm;
